var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceInstallments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20666 6.75586H8.16259M6.20666 10.1319H14.1644M6.20666 13.4945H14.1644M6.20666 16.8705H14.1644M11.7798 23H14.1644M18.438 5.46978H22.792V4.18368C22.792 2.97797 21.814 2 20.6083 2M20.6083 2C19.4026 2 18.438 2.97797 18.438 4.18368V10.641M20.6083 2H4.94737C3.33975 2 2.02686 3.31289 2.02686 4.92051V27.9756L3.67467 26.4215L5.26889 27.9086L6.76934 26.5019L8.35015 27.989L9.99796 26.4349L11.686 28.0292L13.3606 26.4483L15.0754 28.056L16.7232 26.5019L18.438 28.1229V18.6255M6.20666 20H14.1644",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5295 21.1028C27.1032 21.1028 30.0002 18.2058 30.0002 14.6321C30.0002 11.0585 27.1032 8.1615 23.5295 8.1615C19.9559 8.1615 17.0588 11.0585 17.0588 14.6321C17.0588 18.2058 19.9559 21.1028 23.5295 21.1028Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8635 11.7668V15.4375H21.0636",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceInstallments);
export default __webpack_public_path__ + "static/media/deviceInstallments.a78e77ab528a39bf92a5f8f191e3615e.svg";
export { ForwardRef as ReactComponent };